import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "total", "selectionStep", "confirmationStep"]
  static values = {
    amounts: Array
  }

  connect() {
    this.amountsValue = this.checkboxTargets.map(checkbox => {
      return parseFloat(checkbox.dataset.amount || 0) / 100
    })
    this.updateTotal()
  }

  showConfirmation(event) {
    event.preventDefault()
    
    const form = event.target.closest('form')
    const selectedInvoices = this.checkboxTargets
      .filter(checkbox => checkbox.checked)
      .map(checkbox => {
        const row = checkbox.closest('tr')
        return {
          id: checkbox.value,
          number: row.querySelector('td:nth-child(2)').textContent.trim(),
          amount: row.querySelector('td:nth-child(4)').textContent.trim()
        }
      })
    
    if (selectedInvoices.length === 0) {
      alert('Please select at least one invoice')
      return
    }

    const confirmationMessage = this.confirmationStepTarget.querySelector('.confirmation-message')
    const invoiceNumbers = selectedInvoices.map(invoice => invoice.number).join(', ')
    const total = this.totalTarget.textContent
    const paymentSource = this.confirmationStepTarget.dataset.paymentSource
    
    confirmationMessage.innerHTML = `Confirm the payment of <strong>${invoiceNumbers}</strong> for a total amount of <strong>${total}</strong> to be charged from <strong>${paymentSource}</strong>`

    this.selectionStepTarget.classList.add('d-none')
    this.confirmationStepTarget.classList.remove('d-none')
  }

  backToSelection() {
    this.confirmationStepTarget.classList.add('d-none')
    this.selectionStepTarget.classList.remove('d-none')
  }

  toggleAmount() {
    this.updateTotal()
  }

  updateTotal() {
    const total = this.checkboxTargets.reduce((sum, checkbox, index) => {
      return sum + (checkbox.checked ? this.amountsValue[index] : 0)
    }, 0)
    
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    })
    
    this.totalTarget.textContent = formatter.format(total)
  }
}
